// extracted by mini-css-extract-plugin
export default {"root":"Header_root__KkSbk","appTitle":"Header_appTitle__2m0NM"};